import { render, staticRenderFns } from "./Echange.vue?vue&type=template&id=824ecc8c&"
import script from "./Echange.vue?vue&type=script&lang=js&"
export * from "./Echange.vue?vue&type=script&lang=js&"
import style0 from "./Echange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports